var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTimeRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5714 0C10.3571 0 11.875 0.63194 13.125 1.89583C14.375 3.15972 15 4.69444 15 6.5C15 8.30556 14.375 9.8403 13.125 11.1042C11.875 12.3681 10.3571 13 8.5714 13C6.80804 13 5.29018 12.3681 4.01786 11.1042L5.0558 10.0547C6.01562 11.0477 7.1875 11.5443 8.5714 11.5443C9.9554 11.5443 11.1328 11.0534 12.1038 10.0716C13.0748 9.0898 13.5603 7.89931 13.5603 6.5C13.5603 5.10069 13.0748 3.91016 12.1038 2.92839C11.1328 1.94661 9.9554 1.45573 8.5714 1.45573C7.1875 1.45573 6.01004 1.94661 5.03906 2.92839C4.06808 3.91016 3.58259 5.10069 3.58259 6.5H5.72545L2.8125 9.4115L2.77902 9.3099L0 6.5H2.14286C2.14286 4.69444 2.76786 3.15972 4.01786 1.89583C5.26786 0.63194 6.78571 0 8.5714 0ZM7.8683 3.6224H8.9397V6.66927L11.4174 8.19271L10.9152 9.0729L7.8683 7.21094V3.6224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTimeRestoreIcon);
export default __webpack_public_path__ + "static/media/WhiteTimeRestoreIcon.a0e29b4f0fb4b98b99cec3aeadf4c25a.svg";
export { ForwardRef as ReactComponent };